import React, { useState } from "react";
import Button from '@mui/material/Button';
import { Container, Grid, Typography, Box, Divider, FormControl, InputLabel, Select, MenuItem, IconButton, Menu } from "@mui/material";
import Block1 from 'src/components/Stepper/Texts/Block1';
import Block2 from 'src/components/Stepper/Texts/Block2';
import Block3 from 'src/components/Stepper/Texts/Block3';
import Block4 from 'src/components/Stepper/Texts/Block4';
import Block5 from 'src/components/Stepper/Texts/Block5';
import Block8 from 'src/components/Stepper/Texts/Block8';
import Block9 from 'src/components/Stepper/Texts/Block9';
import logo2 from "../../assets/img/logo2.png";
import i18n from 'src/i18n/i18n';
import TranslateIcon from '@mui/icons-material/Translate';

function Info() {
  const [infoBlock, setInfoBlock] = useState("");
  const [language, setLanguage] = useState(i18n.language);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const updateSelected = (e) => {
    setInfoBlock(e.target.value);
  };
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
    setLanguage(lng);
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function Comps({ infoBlock }) {
    if (infoBlock === 1) {
      return (
        <Container><Block1 type={1} /></Container>
      );
    } else if (infoBlock === 2) {
      return (
        <Container><Block2 /></Container>
      );
    } else if (infoBlock === 3) {
      return (
        <Container><Block3 /></Container>
      );
    } else if (infoBlock === 4) {
      return (
        <Container><Block4 /></Container>
      );
    } else if (infoBlock === 5) {
      return (
        <Container><Block5 /></Container>
      );
    } else if (infoBlock === 6) {
      return (
        <Container><Block1 type={6} /></Container>
      );
    } else if (infoBlock === 7) {
      return (
        <Container><Block1 type={7} /></Container>
      );
    } else if (infoBlock === 8) {
      return (
        <Container><Block8 /></Container>
      );
    } else if (infoBlock === "9") {
      return (
        <Container><Block9 /></Container>
      );
    }
  }

  function t(key: string): string {
    return i18n.t(key);
  }

  return (
    <>
      <div style={{ backgroundImage: `url(${logo2})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", minHeight: "95vh" }}>
        <Container>
          <Box style={{ marginTop: 20, textAlign: "center" }}>
            <img src={require('../../assets/img/logo.png')} width="25%" />
          </Box>
          <Divider style={{ marginTop: 10, marginBottom: 10 }}></Divider>
        </Container>

        <Container style={{ backgroundImage: (require('../../assets/img/logo.png')) }}>
          <Grid item xs={12} md={2} style={{textAlign: 'right'}}>
            {/* <IconButton
                aria-label="language"
                aria-controls="language-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <TranslateIcon />
                {language === 'es' ? 'Español' : 'English'}
            </IconButton>
            <Menu
                id="language-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'language-button',
                }}
              >
                <MenuItem onClick={() => changeLanguage('es')}>Español</MenuItem>
                <MenuItem onClick={() => changeLanguage('en')}>English</MenuItem>
            </Menu> */}
          </Grid>
          <Box>
            <Grid container direction="row" sx={{ pb: 2, mb: 0, textAlign: "center", justifyContent: "center" }}>
              <Grid item sm={6} md={12} lg={12}>
                <Typography variant="h1" sx={{ pb: 0 }}>
                  {t("HOME.WELCOME")}
                </Typography>
              </Grid>
              <Grid item md={12}>
                <Typography variant="h2" sx={{ pb: 2, pt: 0 }}>
                  {t("HOME.SUBHEADING")}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel>{t("HOME.SELECT_PROCEDURE")}</InputLabel>
                  <Select label={t("HOME.SELECT_PROCEDURE")} value={infoBlock} onChange={updateSelected}>
                    <MenuItem value="" disabled>
                      {t("HOME.SELECT_PROCEDURE")}
                    </MenuItem>
                    <MenuItem value={1}>{t("HOME.FIRST_TIME")}</MenuItem>
                    <MenuItem value={2}>{t("HOME.RENEWAL")}</MenuItem>
                    <MenuItem value={3}>{t("HOME.EXCHANGE")}</MenuItem>
                    <MenuItem value={4}>{t("HOME.LOST")}</MenuItem>
                    <MenuItem value={5}>{t("HOME.STOLEN")}</MenuItem>
                    <MenuItem value={6}>{t("HOME.FOREIGNERS")}</MenuItem>
                    <MenuItem value={7}>{t("HOME.NON_LOCALS")}</MenuItem>
                    <MenuItem value={8}>{t("HOME.TRANSPORT")}</MenuItem>
                    <MenuItem value={"9"}>{t("HOME.CANCEL_APPOINTMENT")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </Container>
        <Comps infoBlock={infoBlock} />

        {!(infoBlock == "9" || infoBlock == "8") &&
          <Grid display="flex" sx={{ mt: 2, pb: 4, alignItems: "center", justifyContent: "center" }}>
            <Grid item sm={12}>
              <Button variant="contained"  href={'/process?formality_id=' + infoBlock} sx={{ width: 200 }} disabled={!infoBlock}>{t("HOME.START")}</Button>
            </Grid>
          </Grid>
        }
        <Box>
          <Grid container direction="row" sx={{ pb: 2, mb: 0, textAlign: "center", justifyContent: "center" }}>
            <Grid item xs={6} md={6}>
              <Box style={{ marginTop: 5 }}>
                <img src={require('../../assets/img/sspe.png')} width="17%" />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
}

export default Info;
